import banks from "../../../assets/data/banks.json";
import getErrorMessage from "./get-error-message";
import makeStartPayload from "./make-start-payload";

/**
 * @typedef {object} BankAccount
 *
 * @property {string} bankCode
 * @property {string} bankName
 * @property {string} number
 * @property {string} holder
 */

export class UserVaccountAider {
    /** @param {BankAccount} param0 */
    static getAccountText({ bankName, holder, number } = {}) {
        if ([bankName, holder, number].some((v) => !v)) return null;
        else return `${bankName} ${number} (예금주: ${holder})`;
    }

    /** @param {BankAccount} param0 */
    static getBankName({ bankCode, bankName } = {}) {
        return bankName || banks.find(({ code }) => code == bankCode)?.name || null;
    }

    static getErrorMessage = getErrorMessage;
    static makeStartPayload = makeStartPayload;
}
